import axiosInstance from "../axiosInstance";

export const arciveOrderService = {
  fetch: async (query = "") => {
    try {
      const response = await axiosInstance.get(
        `/proxy-historical/orders?${query}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async (obj) => {
    try {
      const response = await axiosInstance.post(
        `/proxy-historical/orders/advanced-filter`,
        obj
      );
      return response.data;
    } catch (error) {
      console.error("Error filtering historical shipments:", error);
      throw error;
    }
  },

  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/archive-order", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      const response = await axiosInstance.patch(`/archive-order/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/archive-order/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteHistoricalData: async (id) => {
    try {
      let response = await axiosInstance.delete(
        `/proxy-historical/orders/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  syncHistoricalData: async (data) => {
    try {
      const response = await axiosInstance.post("/sync-orders", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchUniqueValues: async (client_id, field, search, limit = 15, skip = 0) => {
    try {
      let endpoint = `/proxy-historical/orders/unique/${field}?`;

      if (client_id) {
        endpoint += `&client_id=${client_id}`;
      }
      if (search) {
        endpoint += `&search=${search}`;
      }

      const response = await axiosInstance.get(
        `${endpoint}&limit=${limit}&skip=${skip}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching unique values:", error);
      throw error;
    }
  },
};
